import swal from 'sweetalert2'
import api from '../../models/issue'
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
import moment from 'moment'
// import { nextTick } from 'vue'
// const sound_success = require('@/assets/success.mp3')

export default {
  name: 'issueadd',
  components: { QrcodeStream, QrcodeCapture },
  data() {
    return {
      is_load: false,
      result_data: {
        pagination: [],
        count: 0
      },
      isu_code: 'IS' + moment().format('YYYYMM') + 'XXXX',
      isu_date: moment().format('DD/MM/YYYY'),
      isu_note: '',
      isu_user: '',
      isu_dts: [],
      // qr camera
      qr_camera_active: false,
      qr_camera_allow: false,
      qr_camera_message: '',
      qr_camera_pause: false,
      qr_camera_result: '',
      qr_camera_state: 1,
      qr_camera_torch_active: false,
      qr_camera_torch_not_support: false,
      // qr machine
      qr_machine_active: false,
      qr_machine_result: '',
      qr_machine_state: 1,
      qr_machine_status: 0,
      // check error
      is_allow: false,
      // go back params
      search_text: '',
      search_date: null,
      active_page: 1,
      // audio
      audio_success: null,
      audio_error: null
    }
  },
  created() {
    this.checkOAuth()
    this.getIssueDetailTemp()
    this.search_text = typeof this.$route.params.search_text !== 'undefined' ? this.$route.params.search_text : ''
    this.search_date = typeof this.$route.params.search_date !== 'undefined' ? this.$route.params.search_date : null
    this.active_page = typeof this.$route.params.active_page !== 'undefined' ? this.$route.params.active_page : 1
    this.audio_success = new Audio('../../static/assets/sound/success.mp3')
    this.audio_error = new Audio('../../static/assets/sound/error.mp3')
    this.isu_user = this.$store.state.user.fullname
  },
  mounted() {
    setTimeout(() => {
      let myModal = document.getElementById('qr_camera_modal')
      myModal.addEventListener('hide.bs.modal', event => {
        if (event.target.id === 'qr_camera_modal') {
          this.qr_camera_torch_active = false
        }
      })
      window.addEventListener('keypress', e => {
        if (this.qr_machine_active === true) {
          this.onMachineScan(e.key)
        }
      })
    }, 1000)
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'issue',
        params: {
          search_text: this.search_text,
          search_date: this.search_date,
          active_page: this.active_page
        }
      })
    },
    // camera scan
    startCameraScan() {
      this.qr_camera_active = true
      this.qr_camera_pause = false
      $('#qr_camera_modal').modal('show')
    },
    stopCameraScan() {
      $('#qr_camera_modal').modal('hide')
      setTimeout(() => {
        this.qr_camera_active = false
        this.qr_camera_pause = true
      }, 200)
    },
    async onInit(promise) {
      try {
        const { capabilities } = await promise
        this.qr_camera_torch_not_support = !capabilities.torch
        this.qr_camera_active = true
      } catch (error) {
        this.qr_camera_active = false
        if (error.name === 'NotAllowedError') {
          this.qr_camera_message = 'You need to grant camera access permisson.'
        } else if (error.name === 'NotFoundError') {
          this.qr_camera_message = 'No camera on this device.'
        } else if (error.name === 'NotSupportedError') {
          this.qr_camera_message = 'Secure context required (HTTPS, localhost).'
        } else if (error.name === 'NotReadableError') {
          this.qr_camera_message = 'Is the camera already in use.'
        } else if (error.name === 'OverconstrainedError') {
          this.qr_camera_message = 'Installed cameras are not suitable.'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.qr_camera_message = 'Stream API is not supported in this browser.'
        }
      }
    },
    onDecode(result) {
      this.qr_camera_result = result
      this.qr_camera_pause = true
      let form_data = {
        qrcode: result
      }
      api.addIssueDetailTemp(
        this.$store.state.URLHost,
        form_data,
        this.header,
        result => {
          if (result.response === true) {
            this.isu_dts.push(result.data)
            this.sortArray()
            this.checkAllow()
            this.soundSuccess()
            this.qr_camera_state = 2
          } else {
            this.soundError()
            this.qr_camera_state = 3
          }
          setTimeout(() => {
            this.qr_camera_result = ''
            this.qr_camera_state = 1
            this.qr_camera_pause = false
          }, 1000)
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.soundError()
          setTimeout(() => {
            this.qr_camera_result = ''
            this.qr_camera_state = 1
            this.qr_camera_pause = false
          }, 1000)
        }
      )
    },
    // machine scan
    startMachineScan() {
      this.qr_machine_active = true
      this.qr_machine_state = 1
      this.qr_machine_result = ''
      $('#qr_machine_modal').modal('show')
    },
    stopMachineScan() {
      this.qr_machine_active = false
      this.qr_machine_state = 1
      this.qr_machine_result = ''
      $('#qr_machine_modal').modal('hide')
    },
    resetMachineScan() {
      this.qr_machine_state = 0
      setTimeout(() => {
        this.qr_machine_active = false
        this.qr_machine_state = 1
        this.qr_machine_result = ''
      }, 1000)
    },
    onMachineScan(key) {
      if (key === 'Enter' && this.qr_machine_active === true) {
        this.qr_machine_active = false
        let form_data = {
          qrcode: this.qr_machine_result
        }
        api.addIssueDetailTemp(
          this.$store.state.URLHost,
          form_data,
          this.header,
          result => {
            if (result.response === true) {
              this.isu_dts.push(result.data)
              this.sortArray()
              this.qr_machine_state = 3
              this.qr_machine_status = 1
              this.checkAllow()
              this.soundSuccess()
            } else {
              this.qr_machine_state = 3
              this.qr_machine_status = 0
              this.soundError()
            }
            setTimeout(() => {
              this.qr_machine_state = 1
              this.qr_machine_result = ''
              this.qr_machine_active = true
            }, 1000)
          },
          error => {
            this.alert_msg('error', 'An error occurred.', error.message)
            this.soundError()
            setTimeout(() => {
              this.qr_machine_state = 1
              this.qr_machine_result = ''
              this.qr_machine_active = true
            }, 1000)
          }
        )
      } else {
        if (key.length === 1 && /[a-zA-Z0-9- ]/.test(key)) {
          this.qr_machine_result += key
        }
        if (this.qr_machine_result.length === 0) {
          this.qr_machine_state = 1
        } else {
          this.qr_machine_state = 2
        }
      }
    },
    // qr scanned
    getIssueDetailTemp() {
      this.is_load = true
      this.isu_dts = []
      api.getIssueDetailTemp(
        this.$store.state.URLHost,
        this.header,
        result => {
          this.is_load = false
          if (result.response === true) {
            this.isu_dts = result.data.isu_dts
            this.sortArray()
            this.checkAllow()
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.is_load = false
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    // qr delete
    deleteIssueDetailTemp(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete part id : ' + obj.pr_id_number,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            this.is_load = true
            api.deleteIssueDetailTemp(
              this.$store.state.URLHost,
              obj.isudt_id,
              this.header,
              result => {
                this.is_load = false
                if (result.response === true) {
                  let index = this.isu_dts.findIndex(row => row.isudt_id === obj.isudt_id)
                  if (index > -1) {
                    this.isu_dts.splice(index, 1)
                  }
                  this.checkAllow()
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
              },
              error => {
                this.is_load = false
                this.alert_msg('error', 'An error occurred.', error.message)
              }
            )
          }
        })
    },
    // sort array
    sortArray() {
      if (this.isu_dts.length > 0) {
        this.isu_dts.sort((a, b) => b.isudt_id - a.isudt_id)
      }
    },
    // check allow
    checkAllow() {
      this.is_allow = false
      if (this.isu_dts.length > 0 && !this.isu_dts.some(row => row.prs_inout === 0) && !this.isu_dts.some(row => row.cycle_check === 1)) {
        this.is_allow = true
      }
    },
    addIssue() {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm add issue part : ' + this.isu_dts.length + ' part serial.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, do it!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            this.is_load = true
            let form_data = {
              isu_note: this.isu_note,
              isu_dts: this.isu_dts
            }
            api.addIssue(
              this.$store.state.URLHost,
              form_data,
              this.header,
              result => {
                this.is_load = false
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                  this.$router.push({
                    name: 'issueedit',
                    params: {
                      isu_id: result.data.isu.isu_id,
                      search_text: this.search_text,
                      search_date: this.search_date,
                      active_page: this.active_page
                    }
                  })
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
              },
              error => {
                this.is_load = false
                this.alert_msg('error', 'An error occurred.', error.message)
              }
            )
          }
        })
    },
    soundSuccess() {
      // this.audio_success.currentTime = 0
      this.audio_success.play()
    },
    soundError() {
      // this.audio_error.currentTime = 0
      this.audio_error.play()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/issueadd.js